import { setShare, invokeShare as webxInvokeShare } from '@didi/webx-js'
/**
 * @description 分享事件
 * @author yanchaoren
 */

/**
 * 拉起分享
 */
export default function invokeShare () {
    const shareData = window.__DATA__.shareData
    setShare(shareData)
    webxInvokeShare()
}
